import * as React from "react";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function SelectLabels({
  categoryData,
  text,
  valueKey,
  labelKey,
  onSelectChange,
  previousValue,
}) {
  const [selectedValue, setSelectedValue] = React.useState(previousValue || "");

  React.useEffect(() => {
    if (previousValue && previousValue !== selectedValue) {
      setSelectedValue(previousValue);
      // Call onSelectChange with the name instead of the value
      const selectedItem = categoryData?.find(
        (item) => item[valueKey] === previousValue
      );
      onSelectChange(selectedItem ? selectedItem[labelKey] : previousValue);
    }
  }, [previousValue, selectedValue, onSelectChange, categoryData, valueKey, labelKey]);

  const handleChange = React.useCallback(
    (event) => {
      const selectedItem = categoryData?.find(
        (item) => item[valueKey] === event.target.value
      );
      const selectedName = selectedItem ? selectedItem[labelKey] : "";

      setSelectedValue(event.target.value);
      onSelectChange(selectedName); // Return the name instead of the value
    },
    [onSelectChange, categoryData, valueKey, labelKey]
  );

  return (
    <FormControl required sx={{ width: "100%", height: "100%", minWidth: 200 }}>
      <Select
        value={selectedValue}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        sx={{
          width: "100%",
          height: "100%",
          p: 1,
          "& .MuiOutlinedInput-input": { p: 0 },
          "& .MuiSelect-select": { p: 0 },
        }}
      >
        <MenuItem value="">
          <em>{text}</em>
        </MenuItem>
        {Array.isArray(categoryData) &&
          categoryData.map((item) => (
            <MenuItem key={item[valueKey]} value={item[valueKey]}>
              {item[labelKey]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
